import { render } from "./CatalogBody.vue?vue&type=template&id=b3955b0e&scoped=true"
import script from "./CatalogBody.vue?vue&type=script&lang=js"
export * from "./CatalogBody.vue?vue&type=script&lang=js"

import "./../../assets/styles/catalog.scss?vue&type=style&index=0&id=b3955b0e&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3955b0e"]])

export default __exports__